<template>
  <body id="apps" class="fixed-header" :class="theme == 'dark-mode' ? 'bg-dark' : 'bg-dark'">
    <div :class="theme == 'dark-mode' ? 'login-wrapper-dark' : 'login-wrapper'">
      <!-- START Login Background Pic Wrapper-->
      <div class="bg-pic"></div>
      <!-- <img src="logo.png" alt="logo" class="logo" data-src="logo.png" data-src-retina="logo.png"
        v-if="is_white_label == 0" /> -->
      <!-- END Login Background Pic Wrapper-->
      <!-- START Login Right Container-->
      <div class="login-container" :class="theme == 'dark-mode' ? 'background-dark' : 'background-white'">
        <div class="p-l-50 p-r-50 p-t-20 sm-p-l-15 sm-p-r-15 sm-p-t-40">
          <div align="center" :style="is_white_label == 1 ? 'margin-top: 60%' : ''">
            <!--==============================================================================
						=            Logo pada bagian ini dapat berubah-ubah sesuai kebutuhan            =
						===============================================================================-->
            <!-- <img class="mr-4" src="../../../public/assets/img/logo.png" alt="logo" data-src="logo.png" data-src-retina="logo.png" width="45%"
              v-if="is_white_label == 0" style="margin-top: 30px;" />
            <img src="../../../public/assets/img/logo_au.png" alt="logo" data-src="logo_au.png" data-src-retina="logo_au.png" width="25%" v-if="is_white_label == 0" style="margin-top: 30px;" /> -->
            <!--============================  End of LOGO LOGIN  ============================-->
          </div>
          <p align="center" class="h2" :class="theme == 'dark-mode' ? 'font-dark' : 'font-light'"
            style="margin-top: 50px;">
            <!-- Online Media Monitoring -->
            MFS
          </p>
          <p class="m-t-5 align-left" :class="theme == 'dark-mode' ? 'font-dark' : 'font-light'">
            Silahkan masukan Nama Pengguna dan Kata Sandi Anda untuk melanjutkan.
          </p>

          <div id="notif" v-if="isError" :key="notif_key">
            <alert-dynamic-component :type="notif.type" :title="notif.title" :subtitle="notif.subtitle" />
          </div>

          <!-- START Login Form -->
          <form id="form-login" class="p-t-15" role="form" @submit.prevent="login">
            <!-- START Form Control-->
            <div class="form-group form-group-default background-transparent rounded"
              :class="theme == 'dark-mode' ? 'border border-secondary' : ''">
              <label :class="theme == 'dark-mode' ? 'font-dark' : 'font-light'">Nama Pengguna</label>
              <div class="controls">
                <input v-model="username" type="text" name="username" placeholder="Nama Pengguna"
                  class="form-login-custom" :class="theme == 'dark-mode' ? 'font-dark' : 'font-light'" required />
              </div>
            </div>
            <!-- END Form Control-->
            <!-- START Form Control-->
            <div class="form-group form-group-default background-transparent rounded"
              :class="theme == 'dark-mode' ? 'border border-secondary' : ''">
              <label for="input-password" :class="theme == 'dark-mode' ? 'font-dark' : 'font-light'">Kata Sandi</label>
              <div class="controls">
                <i @click="showPassword" :title="show_password ? 'Sembunyikan Password' : 'Tunjukan Password'
                  " style="cursor: pointer; position: absolute; right: 10px;"
                    :class="[show_password ? 'bi bi-eye-slash' : 'bi bi-eye', theme === 'dark-mode' ? 'text-white' : 'text-dark']" />
                <input v-model="password" :type="show_password ? 'text' : 'password'" class="form-login-custom"
                  :class="theme == 'dark-mode' ? 'font-dark' : 'font-light'" name="password" placeholder="Kata Sandi"
                  id="input-password" autocomplete="on" required />
              </div>
            </div>
            <!-- START Form Control-->
            <div class="row">
              <div class="col-md-6 no-padding sm-p-l-10">
                <div class="form-check">
                  <input v-model="remember_me" type="checkbox" id="checkbox1" />
                  <label for="checkbox1" :class="theme == 'dark-mode' ? 'font-dark' : 'font-light'">Ingat Saya</label>
                </div>
              </div>
              <div class="col-md-12 no-padding">
                <button class="btn btn-warning btn-block btn-lg mt-3" type="submit">
                  Masuk
                </button>
                <!-- <button @mouseenter="hover = true" @mouseleave="hover = false" class="div"
                  :class="{ 'div-hover': hover }">Masuk</button> -->
              </div>
            </div>
            <!-- END Form Control-->
          </form>
          <!--END Login Form-->
          <div class="clearfix" />
          <div class="pull-bottom sm-pull-bottom col-md-10 p-l-0">
            <div class="m-b-30 p-r-80 sm-m-t-20 sm-p-r-15 sm-p-b-20 clearfix">
              <div class="col-md-12 no-padding">
                <!-- <p class="small-text normal hint-text" :class="theme == 'dark-mode' ? 'font-dark' : 'font-light'">
                  Online Media Monitoring © {{ tahun_ini }} All Rights Reserved.
                  <a href="#" @click.prevent="cookiePolicy">Kebijakan Cookie</a>.
                </p> -->

                <p class="small-text normal hint-text pull-right"
                  :class="theme == 'dark-mode' ? 'font-dark' : 'font-light'">
                  Sibernetik
                  <span class="hint-text"> v{{ version }} </span>
                </p>
                <div class="clearfix" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END Login Right Container-->
    </div>
    <floating-loader-component key="loading_key" v-if="isLoading" :text="loading_text" />
    <modal-dynamic-component v-if="modal" :key="modal_key" :modal="modal" :data="modal.data" />
  </body>
</template>

<script>
import floating_loader from "@/views/components/floating_loader.vue";
import alert_dynamic from "@/views/components/alert_dynamic.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_cookie_policy from "../components/modal_cookie_policy.vue";
import VueJwtDecode from "vue-jwt-decode";
import Cookie from "js-cookie";

export default {
  name: "Login",
  title: "Login | Sibernetik",
  components: {
    "floating-loader-component": floating_loader,
    "alert-dynamic-component": alert_dynamic,
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      version: process.env.PACKAGE_VERSION,
      theme: this.$store.getters.theme
        ? this.$store.getters.theme
        : "light-mode",
      username: "",
      password: "",
      remember_me: false,
      isLoading: false,
      notif: {},
      isError: false,
      notif_key: 0,
      fail_count: 0,
      loading_key: 10,
      loading_text: "Mohon tunggu.<br>Memeriksa kredendsial...",
      show_password: false,
      modal: null,
      modal_key: 20,
      is_white_label: parseInt(process.env.VUE_APP_WHITELABEL),
      tahun_ini: new Date().getFullYear(),
    };
  },
  methods: {
    login: function () {
      let data = {
        username: this.username,
        password: btoa(this.password),
        ref: "web",
        remember_me: this.remember_me ? 1 : 0,
      };
      this.isLoading = true;

      this.$store
        .dispatch("login", data)
        .then((token) => {
          this.loading_text = "Proses masuk berhasil";
          this.loading_key++;
          let user = VueJwtDecode.decode(token);
          let last_page = Cookie.get("medmon_last_page");
          if (user.role == 1) {
            window.location.href = "/admin";
          } else {
            if (
              (this.$store.getters.user.project.project_detail.tipe == 1 ||
                this.$store.getters.user.project.project_detail.tipe == 2) &&
              this.$store.getters.user.role != 5
            ) {
              if (last_page) {
                Cookie.remove("medmon_last_page");
                window.location.href = last_page;
              } else {
                window.location.href = "/";
              }
            } else {
              this.notif.type = "danger";
              this.notif.title = "Maaf!";
              this.notif.subtitle =
                "Versi aplikasi project tidak sesuai, silahkan hubungi Administrator.";
              this.notif_key++;
              this.isError = true;
              this.isLoading = false;
            }
          }
        })
        .catch((err) => {
          if (err.status == 500) {
            this.isLoading = false;
            this.notif.type = "danger";
            this.notif.title = err.statusText + "<br>";
            this.notif.subtitle = err.data.status;
          } else {
            this.fail_count++;
            this.isLoading = false;
            if (this.fail_count > 4) {
              this.notif.type = "danger";
              this.notif.title = "Login Gagal!<br>";
              this.notif.subtitle =
                "Username atau Password salah. Silakan hubungi Administrator jika Anda lupa password.";
            } else {
              this.notif.type = "danger";
              this.notif.title = "Login Gagal!<br>";
              this.notif.subtitle =
                "Username atau Password salah. Silakan coba lagi.";
            }
          }

          this.isError = true;
          this.notif_key++;
        });
    },
    showPassword: function () {
      if (this.show_password) {
        this.show_password = false;
      } else {
        this.show_password = true;
      }
    },
    cookiePolicy: function () {
      let modal = {
        title: "Cookie Policy",
        subtitle: "Last Update 27-11-2020",
        component: modal_cookie_policy,
      };
      if (this.modal) {
        this.modal_key++;
      } else {
        this.modal = modal;
      }
    },
  },
  beforeCreate: function () {
    const app = document.getElementById("apps");
    if (app) {
      if (this.theme == "light-mode") {
        app.classList.remove("dark-mode");
        app.classList.add("light-mode");
      } else {
        app.classList.remove("light-mode");
        app.classList.add("dark-mode");
      }
    }
  },
  created: function () {
    if ("ref" in this.$route.query) {
      if (atob(this.$route.query.ref) == "logout") {
        this.notif.type = "success";
        this.notif.title = atob(this.$route.query.log_t);
        this.notif.subtitle = atob(this.$route.query.log);
        this.isError = true;
        this.notif_key++;
      }
    }
  },
};
</script>

<style scoped>
.login-container img {
  text-align: center;
}

.background-transparent {
  background: transparent !important;
  border: rgb(216, 213, 213) 0.5 solid !important;
}

.background-white {
  background: rgba(255, 255, 255, 0.9) !important;
}

.background-dark {
  /* background: #3a4149 !important; */
  /* background: #101113 !important; */
  background: rgba(22, 22, 22, 0.7) !important;
  /* opacity: 0.7; */
}

.font-dark {
  /* color: rgb(216, 213, 213) !important; */
  color: white !important;
  opacity: 1;
}

.font-light {
  color: black !important;
}

.form-login-custom {
  border: none !important;
  width: 100%;
  background-color: transparent !important;
  border-radius: 5px;
}

body {
  overflow: hidden;
  /* Hide scrollbars */
}

.logo {
  width: 130px;
  height: 120px;
}
</style>
